import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { toggleModalDiagramRestore, diagramRestore } from '../../../redux/main/main.actions';
import { selectIsModalDiagramRestoreEnabled, selectModalDiagramRestoreData } from '../../../redux/main/main.selectors';

import { trackEvent } from '../../../lib/analytics';

import Modal from '../Modal/Modal';
import './ModalDiagramRestore.scss';

export const ModalDiagramRestore = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const isOpen = useSelector(selectIsModalDiagramRestoreEnabled);
    const modalData = useSelector(selectModalDiagramRestoreData);

    const [value, setValue] = useState(modalData?.diagram?.title || '');

    useEffect(() => {
        if (!modalData?.diagram?.title) return;

        if (value !== modalData?.diagram?.title) {
            setValue(modalData?.diagram?.title || '');
        }
        return () => { };
    }, [modalData]);

    const handleSave = () => {
        trackEvent('app_modal_diagram_restore_submit', {
            page: 'app',
            type: 'modals',
        });
        dispatch(diagramRestore(modalData?.diagram?.id));
        dispatch(toggleModalDiagramRestore(null));
    };

    const handleCancel = () => {
        dispatch(toggleModalDiagramRestore(null));
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-diagram-restore`}
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{t('m_diagram_restore.header')}</div>
            <div className="modal-content-body">
                <div className='description-text'>{t('m_diagram_restore.desc_prefix')}<span className='text-title-bold'>{value}</span>.</div>
                <div className='buttons-wrap'>
                    <button className='button-second' onClick={() => handleCancel()}>{t('b.cancel')}</button>
                    <button onClick={() => handleSave()}>{t('b.restore')}</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalDiagramRestore;
